class SingleBarCharts {
	public constructor(charts: NodeListOf<HTMLElement>) {
		const observer: IntersectionObserver = new IntersectionObserver(this.callback, {
			root: null,
			threshold: 1
		});
		charts.forEach((chart: HTMLElement) => observer.observe(chart));
	}

	private callback(entries: Array<IntersectionObserverEntry>, observer: IntersectionObserver): void {
		entries.forEach((entry: IntersectionObserverEntry) => {
			if (entry.isIntersecting) {
				observer.unobserve(entry.target);
				entry.target.classList.add('animate');
			}
		});
	}
}

const initSingleBarCharts = () => {
	const charts: NodeListOf<HTMLElement> = document.querySelectorAll('.single-bar-chart.is-animated');

	if (charts.length > 0) {
		new SingleBarCharts(charts);
	}
}

if (/complete|interactive|loaded/.test(document.readyState)) {
	initSingleBarCharts()
} else {
	document.addEventListener('DOMContentLoaded', () => initSingleBarCharts());
}
